import { Component, HostListener, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { translations } from '@utils/translations';
import { AppStarterService } from '@services';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet],
	template: ` <router-outlet /> `,
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: `
		:host {
		}
	`,
})
export class AppComponent {
	private appStarterService: AppStarterService = inject(AppStarterService);

	constructor() {
		this.appStarterService.initServices();
	}

	@HostListener('document:touchend', ['$event'])
	onTouchEnd(event: TouchEvent): void {
		const target = event.target as HTMLElement;
		const isInput =
			target.matches('input, textarea, select, [contenteditable="true"]') ||
			target.closest(
				'input, textarea, select, kui-input, kui-textarea, kui-select, kui-autocomplete, kui-search-input',
			);

		if (!isInput) {
			const active = document.activeElement as HTMLElement;
			if (active && (active.tagName === 'INPUT' || active.tagName === 'TEXTAREA')) {
				active.blur();
			}
		}
	}
}
